import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { Container } from 'react-bootstrap';
import UserTable from './tables/users.table';
import { UserService } from '../../../../service/users.service';
import { defaultCenterMap, mapStyle, User } from '../../../../service/types/types';
import { FeedbackModal } from '../../../common/feedback.modal';


export default function UsersMapTable() {
  
  const [center, setCenter] = useState(defaultCenterMap);
  const [users, setUsers] = useState<User[]>([]);
  const [reloadFlag, setReloadFlag] = useState(false);

  //modal
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<"success" | "error">("success");
  const [modalMessage, setModalMessage] = useState("");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await UserService.find();
        setUsers(data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchUsers();
  }, [reloadFlag]);

  const onSave = (isOk: boolean) => {
    if (isOk) {
      setModalType("success")
      setModalMessage("Usuario Guardado Correctamente")
      setReloadFlag((prev) => !prev); // 👈 alterna el flag y fuerza el useEffect
    } else {
      setModalType("error")
      setModalMessage("Error Guardado Usuario")
    }
    setShowModal(true);
  };

  const handleGo = (lat: number, lng: number) => {
    setCenter({ lat, lng }); // 👈 actualiza el centro del mapa
  };

  return (
    <Container fluid className="p-0">
      <FeedbackModal
        show={showModal}
        onHide={() => setShowModal(false)}
        type={modalType}
        message={modalMessage}
        autoClose={true}   // 👈 se cierra solo en 3s
        duration={3000}
      />
      <GoogleMap mapContainerStyle={mapStyle} center={center} zoom={12}>
        {users.map((user) => (
            user.localidad ? (<Marker key={user.rut} position={{ 
            lat: user.localidad.location.coordinates[1], 
            lng: user.localidad.location.coordinates[0] 
          }} />) : null
        ))}
      </GoogleMap>
      <br/>
      {/* Mitad inferior: Tabla */}
      <div style={{overflowY: 'auto', padding: '1rem' }}>
        <UserTable
          users={users}
          onSave={onSave}
          onGo={handleGo}
        />
      </div>
    </Container>
  );
}